import {
  FeatureFlagProvider,
  type FeatureFlagProviderProps,
} from '@seek/candidate-feature-flag';

import { useAppConfig } from 'src/components/App/useAppConfig';
import { appName } from 'src/config';
import { useSolId } from 'src/hooks/useUserCookies';

import { experimentsToFetch } from './constants';

export const FeatureFlagProviderWrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const value = useFeatureFlagsProviderValue();

  return <FeatureFlagProvider {...value}>{children}</FeatureFlagProvider>;
};

const useFeatureFlagsProviderValue = (): Omit<
  FeatureFlagProviderProps,
  'children'
> => {
  const solId = useSolId();
  const { version } = useAppConfig();

  return {
    shouldEnableOverride: true,
    featureFlagsConfig: [],
    solId,
    experimentsConfig: experimentsToFetch,
    customContext: {
      applicationContext: {
        key: solId,
        namespace: appName,
        build: version,
        version,
      },
    },
  };
};
